<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="qualitySelectItems"
            v-model="item.quality"
            :items="qualitySelectItems"
            :error-messages="qualityErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.strategy.quality')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-checkbox
            v-model="item.part"
            :error-messages="partErrors"
            :label="$t('profile.strategy.part')"

            @input="$v.item.part.$touch()"
            @blur="$v.item.part.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-checkbox
            v-model="item.infill"
            :error-messages="infillErrors"
            :label="$t('profile.strategy.infill')"

            @input="$v.item.infill.$touch()"
            @blur="$v.item.infill.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-checkbox
            v-model="item.support"
            :error-messages="supportErrors"
            :label="$t('profile.strategy.support')"

            @input="$v.item.support.$touch()"
            @blur="$v.item.support.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-checkbox
            v-model="item.denseSupport"
            :error-messages="denseSupportErrors"
            :label="$t('profile.strategy.densesupport')"

            @input="$v.item.denseSupport.$touch()"
            @blur="$v.item.denseSupport.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-checkbox
            v-model="item.skirt"
            :error-messages="skirtErrors"
            :label="$t('profile.strategy.skirt')"

            @input="$v.item.skirt.$touch()"
            @blur="$v.item.skirt.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-checkbox
            v-model="item.raft"
            :error-messages="raftErrors"
            :label="$t('profile.strategy.raft')"

            @input="$v.item.raft.$touch()"
            @blur="$v.item.raft.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-checkbox
            v-model="item.primePillar"
            :error-messages="primePillarErrors"
            :label="$t('profile.strategy.primepillar')"

            @input="$v.item.primePillar.$touch()"
            @blur="$v.item.primePillar.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-checkbox
            v-model="item.oozeShield"
            :error-messages="oozeShieldErrors"
            :label="$t('profile.strategy.oozeshield')"

            @input="$v.item.oozeShield.$touch()"
            @blur="$v.item.oozeShield.$touch()"
          />
        </v-col>

      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
//import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'ProfileStrategyQualityForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.qualityGetSelectItems();
      this.profileStrategyGetSelectItems();
  },
  data() {
    return {
        quality: null,
        part: null,
        infill: null,
        support: null,
        denseSupport: null,
        skirt: null,
        raft: null,
        primePillar: null,
        oozeShield: null,
        profileStrategy: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_quality ||
         this.isLoading_profilestrategy 
       );
    },
      ...mapFields('quality', {
        qualitySelectItems: 'selectItems',
        isLoading_quality : 'isLoading'
      }),
      ...mapFields('profilestrategy', {
        profileStrategySelectItems: 'selectItems',
        isLoading_profilestrategy : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    qualityErrors() {
      const errors = [];

      if (!this.$v.item.quality.$dirty) return errors;

      has(this.violations, 'quality') && errors.push(this.violations.quality);


      return errors;
    },
    partErrors() {
      const errors = [];

      if (!this.$v.item.part.$dirty) return errors;

      has(this.violations, 'part') && errors.push(this.violations.part);



      return errors;
    },
    infillErrors() {
      const errors = [];

      if (!this.$v.item.infill.$dirty) return errors;

      has(this.violations, 'infill') && errors.push(this.violations.infill);



      return errors;
    },
    supportErrors() {
      const errors = [];

      if (!this.$v.item.support.$dirty) return errors;

      has(this.violations, 'support') && errors.push(this.violations.support);



      return errors;
    },
    denseSupportErrors() {
      const errors = [];

      if (!this.$v.item.denseSupport.$dirty) return errors;

      has(this.violations, 'denseSupport') && errors.push(this.violations.denseSupport);



      return errors;
    },
    skirtErrors() {
      const errors = [];

      if (!this.$v.item.skirt.$dirty) return errors;

      has(this.violations, 'skirt') && errors.push(this.violations.skirt);



      return errors;
    },
    raftErrors() {
      const errors = [];

      if (!this.$v.item.raft.$dirty) return errors;

      has(this.violations, 'raft') && errors.push(this.violations.raft);



      return errors;
    },
    primePillarErrors() {
      const errors = [];

      if (!this.$v.item.primePillar.$dirty) return errors;

      has(this.violations, 'primePillar') && errors.push(this.violations.primePillar);



      return errors;
    },
    oozeShieldErrors() {
      const errors = [];

      if (!this.$v.item.oozeShield.$dirty) return errors;

      has(this.violations, 'oozeShield') && errors.push(this.violations.oozeShield);



      return errors;
    },
    profileStrategyErrors() {
      const errors = [];

      if (!this.$v.item.profileStrategy.$dirty) return errors;

      has(this.violations, 'profileStrategy') && errors.push(this.violations.profileStrategy);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        qualityGetSelectItems: 'quality/fetchSelectItems'
      }),
      ...mapActions({
        profileStrategyGetSelectItems: 'profilestrategy/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      quality: {
      },
      part: {
      },
      infill: {
      },
      support: {
      },
      denseSupport: {
      },
      skirt: {
      },
      raft: {
      },
      primePillar: {
      },
      oozeShield: {
      },
      profileStrategy: {
      },
    }
  }
};
</script>
